module.exports = __webpack_public_path__ + "static/media/ki.14d5dc16.svg";